module.exports = __webpack_public_path__ + "img/product_45.8d1bb4f.svg";